if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('input.product-variant-id').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.currentPrice = this.setCurrentPrice();
        this._discountCode = this.dataset.discountCode || null; 

        this.giftSubscriptionItem = document.querySelector('.product-information__selling-plan-wrapper[has-nested-product]')
        
        if(this.giftSubscriptionItem) this.checkNestedProductFromSubscription() 


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      get discountCode() {
        return this._discountCode?.trim() || this.dataset.discountCode?.trim() || null;
      }

      set discountCode(value) {
        this._discountCode = value;
      }

      async applyCartDiscount(response, discountCode) {
        if (!discountCode) return response;

        const body = { discount: discountCode };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        const discountResponse = await fetch(`${routes.cart_update_url}.js`, {
          ...fetchConfig(),
          body: JSON.stringify(body),
        });
        const cart = await discountResponse.json();
        if (!discountResponse.ok || cart.status) {
          throw new Error(cart.description || cart.message || 'Unable to apply the discount code.');
        }

        return { ...response, sections: { ...response.sections, ...cart.sections } };
      }

      setCurrentPrice() {
        const sellingPlansWrapper = this.closest('.landing-product__information')?.querySelector('.product-information__selling-plans-wrapper')
        this.currentPrice = sellingPlansWrapper?.querySelector('input[type="radio"][data-price]:checked')?.dataset.price;
      }

      checkNestedProductFromSubscription() {
        const subscriptionWidget = document.querySelector('.product-information__selling-plans-wrapper')
        
        const variantInputId = this.querySelector('input[name="id"]')
        const nestedVariantInputs = this.form.querySelectorAll('.nested-variant-id');
        const sellingPlan = document.querySelector('.product-information__buy-buttons input[name*="selling_plan"]')
        const quantityInput = document.querySelector('quantity-input .buy-quantity__input')
        const giftQuantityInput = document.querySelectorAll('quantity-input .nested-quantity__input')
        const nestedPropertyInput = this.form.querySelector('input[name="properties[_nested_product_ids]"], input[name="items[0][properties][_nested_product_ids]"]');
        if (!nestedVariantInputs.length || !sellingPlan) return

        const toggleNestedPropertyName = (useItemsFormat) => {
          if (!nestedPropertyInput) return;

          if (useItemsFormat && nestedPropertyInput.name === 'properties[_nested_product_ids]') {
            nestedPropertyInput.name = 'items[0][properties][_nested_product_ids]';
          }

          if (!useItemsFormat && nestedPropertyInput.name === 'items[0][properties][_nested_product_ids]') {
            nestedPropertyInput.name = 'properties[_nested_product_ids]';
          }
        }

        const toggleInputs = () => {
          if (this.giftSubscriptionItem.classList.contains('active')) {
            if(quantityInput) quantityInput.name = 'items[0][quantity]'
            giftQuantityInput.forEach(input => input.disabled = false)
            if(variantInputId) variantInputId.name = 'items[0][id]'
            nestedVariantInputs.forEach(input => input.disabled = false)
            sellingPlan.name = 'items[0][selling_plan]'
            toggleNestedPropertyName(true)
          } else {
            if(quantityInput) quantityInput.name = 'quantity'
            giftQuantityInput.forEach(input => input.disabled = true)
            if(variantInputId) variantInputId.name = 'id'
            if(variantInputId) variantInputId.disabled = false
            nestedVariantInputs.forEach(input => input.disabled = true)
            sellingPlan.name = 'selling_plan'
            toggleNestedPropertyName(false)
          }
        }

        toggleInputs()

        if(subscriptionWidget) {
          subscriptionWidget.addEventListener('change', () => {
            toggleInputs()
          })
        }
      }

      pushATCEventToDataLayer() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "add_to_cart",
          value: this.currentPrice,
          currency: Shopify.currency.active
        });
      }

      checkTheChildProductForSellingPlan(formData) {
        let itemIdCount = 1

        const parent_id = formData.get('items[0][id]')
        for (const key of formData.keys()) {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          if (match) {
            const index = Number(match[1]);
            if (index === 0) continue;
            itemIdCount++;
            formData.append(`items[${index}][parent_id]`, parent_id);
          }
        }
      }

      normalizeNestedIds(value) {
        if (!value) return '';
        return String(value)
          .split(',')
          .map((id) => Number(String(id).trim()))
          .filter(Boolean)
          .sort((a, b) => a - b)
          .join(',');
      }

      removeNestedItemsFromFormData(formData) {
        const nestedIndexes = [];

        for (const key of formData.keys()) {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          if (!match) continue;

          const index = Number(match[1]);
          if (index > 0) nestedIndexes.push(index);
        }

        nestedIndexes.forEach((index) => {
          formData.delete(`items[${index}][id]`);
          formData.delete(`items[${index}][quantity]`);
          formData.delete(`items[${index}][parent_id]`);
        });
      }

      async skipDuplicateNestedForExistingSubscription(formData) {
        const parentVariantId = Number(formData.get('items[0][id]'));
        const sellingPlanId = Number(formData.get('items[0][selling_plan]'));

        if (!parentVariantId || !sellingPlanId) return;

        const nestedIds = [];
        for (const key of formData.keys()) {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          if (!match) continue;
          const index = Number(match[1]);
          if (index === 0) continue;

          const nestedId = Number(formData.get(key));
          if (nestedId) nestedIds.push(nestedId);
        }

        if (!nestedIds.length) return;

        const nestedIdsFromProperty =
          formData.get('items[0][properties][_nested_product_ids]') ||
          formData.get('properties[_nested_product_ids]') ||
          '';
        const expectedNestedIds = this.normalizeNestedIds(nestedIdsFromProperty) || this.normalizeNestedIds(nestedIds.join(','));

        const cartRes = await fetch(`${routes.cart_url}.js`);
        const cart = await cartRes.json();
        if (!cartRes.ok || !Array.isArray(cart.items)) return;

        const parentLine = cart.items.find((line) => {
          const linePlanId = Number(line?.selling_plan_allocation?.selling_plan?.id || 0);
          const lineVariantId = Number(line?.variant_id || 0);
          if (lineVariantId !== parentVariantId || linePlanId !== sellingPlanId) return false;
          if (line?.parent_relationship) return false;

          const lineNestedProp = this.normalizeNestedIds(line?.properties?._nested_product_ids || '');
          return lineNestedProp === expectedNestedIds;
        });

        if (!parentLine?.key) return;

        const nestedSet = new Set(nestedIds.map((id) => Number(id)));
        const attachedChildren = cart.items.filter((line) => {
          const parentKey =
            line?.parent_relationship?.parent_key ||
            line?.parent_relationship?.parent?.key ||
            line?.parent_relationship?.parent_line_key ||
            null;
          return parentKey === parentLine.key && nestedSet.has(Number(line?.variant_id || 0));
        });

        const allNestedAlreadyAttached = attachedChildren.length === nestedSet.size;
        if (allNestedAlreadyAttached) {
          this.removeNestedItemsFromFormData(formData);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.setCurrentPrice();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // If product is submitted in items[0] format (subscription flow),
        // move only nested ids property to parent line properties.
        if (formData.get('items[0][id]')) {
          const nestedPropKey = 'properties[_nested_product_ids]';
          const nestedPropTargetKey = 'items[0][properties][_nested_product_ids]';

          if (formData.has(nestedPropKey) && !formData.has(nestedPropTargetKey)) {
            const nestedValues = formData.getAll(nestedPropKey);
            formData.delete(nestedPropKey);
            nestedValues.forEach((value) => formData.append(nestedPropTargetKey, value));
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        this.checkTheChildProductForSellingPlan(formData)

        //Next code using for subscription price A/B test. Remove after test is over!
        if (window?.abTests?.subscriptionPrice?.enabled) {
          const currentVariantId = formData.get('id') || formData.get('items[0][id]');
          const { discounts, variation } = window.abTests.subscriptionPrice;
          
          const currentDiscounts = discounts[currentVariantId]
          if (currentDiscounts) {
            const currentDiscount = currentDiscounts[variation];
            this.discountCode = currentDiscount;
          }
        }

        if (localStorage.getItem('first-visited-page')) {
          if (formData.get('id')) {
            formData.append('properties[_first_visited_page]', localStorage.getItem('first-visited-page'));
          } else if (formData.get('items[0][id]')) {
            formData.append('items[0][properties][_first_visited_page]', localStorage.getItem('first-visited-page'));
          }
        };

        const discountCode = this.discountCode;

        this.skipDuplicateNestedForExistingSubscription(formData)
          .catch((error) => {
            console.error('[product-form] skipDuplicateNestedForExistingSubscription failed', error);
          })
          .finally(() => {
            config.body = formData;

            if (this.currentPrice) this.pushATCEventToDataLayer();

            const isDrawerCart = this.cart?.tagName === 'CART-DRAWER';
            const isQuizV2Product = Boolean(this.closest('[id$="__quiz_product_v2"]'));
            const preAddPromise = isDrawerCart && !isQuizV2Product
              ? Promise.resolve()
              : fetch(`${routes.cart_clear_url}.js`);

            preAddPromise
            .then(res => {
              fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then(async (response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButton.querySelector('span').classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                }

                try {
                  response = await this.applyCartDiscount(response, discountCode);
                } catch (error) {
                  console.error('[product-form] applyCartDiscount failed', error);
                  this.handleErrorMessage(error.message);
                }

                if (isQuizV2Product || !this.cart) {
                  window.location.href = `${window.routes.checkout_url}${discountCode ? `?discount=${encodeURIComponent(discountCode)}` : ''}`;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.cart) {
                  this.submitButton.classList.remove('loading');
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading__spinner').classList.add('hidden');
                }
              })
            })
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
